// Tracks Free-plan prompt generations per local day via localStorage.
// Premium users (localStorage flag) bypass the limit entirely.

const STORAGE_KEY = "promptkiste:usage";
const PREMIUM_KEY = "promptkiste-premium";

export const DAILY_LIMIT = 3;

const todayKey = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const isPremium = () => {
  try {
    return localStorage.getItem(PREMIUM_KEY) === "true";
  } catch {
    return false;
  }
};

export const setPremium = (value) => {
  try {
    if (value) {
      localStorage.setItem(PREMIUM_KEY, "true");
    } else {
      localStorage.removeItem(PREMIUM_KEY);
    }
  } catch {
    /* ignore */
  }
};

export const readUsage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { date: todayKey(), count: 0 };
    const parsed = JSON.parse(raw);
    if (parsed.date !== todayKey()) {
      return { date: todayKey(), count: 0 };
    }
    return { date: parsed.date, count: Number(parsed.count) || 0 };
  } catch {
    return { date: todayKey(), count: 0 };
  }
};

export const incrementUsage = () => {
  if (isPremium()) return readUsage();
  const current = readUsage();
  const next = { date: current.date, count: current.count + 1 };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
};

export const remainingToday = () => {
  if (isPremium()) return Infinity;
  const { count } = readUsage();
  return Math.max(0, DAILY_LIMIT - count);
};

export const isLimitReached = () => {
  if (isPremium()) return false;
  return remainingToday() <= 0;
};
